module.exports = __webpack_public_path__ + "img/login.42a92e55.jpg";